import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { ICheckoutDependencies } from 'src/mobx/checkoutStore/types';
import { localeStore } from 'src/mobx/localesStore';
import Input from 'src/view/components/Controls/Input/Input';
import Text, { TEXT } from 'src/view/components/Text/Text';

interface IProps {
  inputKey: keyof ICheckoutDependencies['curbside'];
  label: string;
  value: string;
  error: boolean;
}

const OrderCurbsideInput: React.FC<IProps> = ({ inputKey, label, value, error }: IProps) => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const changeCurbsideInfo = (field: keyof ICheckoutDependencies['curbside']) => (event: ChangeEvent<HTMLInputElement>) => {
    checkoutStore.changeCurbsideInfo(field, event.target.value);
  };

  return (
    <div className="d-flex align-items-center mb-3">
      <Text type={TEXT.ORDER_FIELD} text={label} required />
      <Input
        error={error}
        onChange={changeCurbsideInfo(inputKey)}
        value={value}
        placeholder={localeStore.t(label)}
        className="input-mini family-medium text-size-16 text-elipsis"
      />
    </div>
  );
};

export default observer(OrderCurbsideInput);
